module.exports = __webpack_public_path__ + "img/oneGreen.b09b294d.jpg";